<template>
    <div
        class="ResultPrimer"
        :class="{ 'ResultPrimer--mobile': isMobile, 'ResultPrimer--desktop': !isMobile }">
        <template v-if="isMobile">

            <p
                class="ResultPrimer-copy"
                v-html="translation.calculate.result.primer"/>

            <img
                src="/images/underwater-primer-can.png"
                alt="Primer"
                class="ResultPrimer-image">
            <div class="ResultPrimer-content">

                <strong class="ResultPrimer-title">Hempel's Underwater Primer 26030</strong>
                <span class="ResultPrimer-amount">{{ volume }}L</span>

                <div class="ResultPrimer-suggestion">
                    <small>{{ translation.calculate.result.suggestedAmount }}</small>
                    <div class="hempel-combination-big">
                        <hempel-combination
                            :quantity="biggerCans"
                            size="2.25L"
                            icon="antifoulingBucket"
                            class="ResultPrimer-combination"
                            v-if="biggerCans > 0"/>
                    </div>
                    <small v-if="cans > 0 && biggerCans > 0">+</small>
                    <div class="hempel-combination-small">
                        <span v-if="cans <= 0" class="combination-small-0">0 *</span>
                        <hempel-combination
                            :quantity="cans"
                            size="750ml"
                            icon="antifoulingCan"
                            class="ResultPrimer-combination"
                            v-if="cans > 0"/>
                    </div>
                </div>

            </div>

        </template>
        <template v-else>

            <p
                class="ResultPrimer-copy"
                v-html="translation.calculate.result.primer"/>

            <strong class="ResultPrimer-title">Hempel's Underwater Primer 26030</strong>

            <div class="ResultPrimer-content">
                <img
                    src="/images/underwater-primer-can.png"
                    alt="Primer"
                    class="ResultPrimer-image">

                <div class="ResultPrimer-suggestion">
                    <span class="ResultPrimer-amount">{{ volume }}L</span>
                    <small>{{ translation.calculate.result.suggestedAmount }}</small>
                    <div class="hempel-combination-big">
                        <hempel-combination
                            :quantity="biggerCans"
                            size="2.25L"
                            icon="antifoulingBucket"
                            class="ResultPrimer-combination"
                            v-if="biggerCans > 0"/>
                    </div>
                    <small v-if="cans > 0 && biggerCans > 0">+</small>
                    <div class="hempel-combination-small">
                        <span v-if="cans <= 0" class="combination-small-0">0 *</span>
                        <hempel-combination
                            :quantity="cans"
                            size="750ml"
                            icon="antifoulingCan"
                            class="ResultPrimer-combination"
                            v-if="cans > 0"/>
                    </div>
                </div>
            </div>

        </template>
    </div>

</template>
<script>
import HempelCombination from '@/components/shared/combination/Combination'

export default {
    components: {
        HempelCombination
    },
    props: {
        volume: {
            type: Number,
            required: true
        },
        small: {
            type: Number,
            required: true
        }
    },
    computed: {
        volume() {
            return this.calculateVolume('primer')
        },
        biggerCans() {
            return Math.floor(this.roundUp(this.volume) / 2.25)
        },
        cans() {
            return Math.ceil((this.roundUp(this.volume) - this.biggerCans * 2.25) / 0.75)
        }
    },
    methods: {
        roundUp(number) {
            return Math.ceil(number * 2) / 2
            // return Math.ceil(4 * number) / 4
        },
        roundUpQuarter(number) {
            return Math.ceil(4 * number) / 4
        },
        calculateVolume(type) {
            if (!this.getSelectedProduct || !this.getSelectedProduct.coverage) {
                return 0
            }

            const boatType = this.$route.query.type
            const keel = this.$route.query.keelType || null
            const coverage = this.getSelectedProduct.coverage
            const { dimensions } = this.$route.query
            const unit = dimensions.split('-')[0]

            let volume
            if (
                !dimensions.split('-')[1] &&
                !dimensions.split('-')[2] &&
                !dimensions.split('-')[3] &&
                dimensions.split('-')[4]
            ) {
                volume = dimensions.split('-')[4] / 7.8
            } else {
                const low =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[1] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[1] * 0.3048).toFixed(2))
                const beam =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[2] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[2] * 0.3048).toFixed(2))
                const draft =
                    unit === 'm'
                        ? parseFloat((dimensions.split('-')[3] * 1).toFixed(2))
                        : parseFloat((dimensions.split('-')[3] * 0.3048).toFixed(2))

                if (boatType !== 'sailing') {
                    volume = low * (beam + draft) * 0.85 / 7.8
                } else
                    volume =
                        keel === 'fin'
                            ? low * (beam + draft) * 0.5 / 7.8
                            : low * (beam + draft) * 0.75 / 7.8
            }

            return Math.ceil(volume)
        }
    }
}
</script>
